<template>
    <footer class="l-footer">
        <div class="l-grid">
            <ul class="l-footer__info">
                <li v-if="restaurant.address">
                    <a
                        :href="`https://www.google.com/maps/search/?api=1&query=${googleMapQuery}`"
                        title="Trouver un itinéraire"
                        class="t-link"
                        target="_blank"
                        rel="noopener"
                        v-html="restaurant.address">
                    </a>
                </li>
                <li v-if="restaurant.phone">
                    <a
                        :href="`tel:${restaurant.phone}`"
                        title="Nous téléphoner"
                        class="t-link"
                        target="_blank"
                        rel="noopener"
                    >{{ restaurant.phone }}</a>
                </li>
                <li v-if="restaurant.email" >
                    <a
                        :href="`mailto:${restaurant.email}`"
                        title="Nous envoyer un email"
                        class="t-link"
                        target="_blank"
                        rel="noopener"
                    >{{ restaurant.email }}</a>
                </li>
            </ul>

            <div class="l-footer__opening | o-opening">
                <span
                    v-if="openingDataForToday"
                    class="o-opening__label"
                >
                    <span
                        class="o-opening__item"
                        itemprop="openingHours"
                        :content="today.substring(0, 2) + ' ' + openingDataForToday.hours |hoursArrayToSring"
                    >
                        <span class="o-opening__day">
                            <Icon
                                icon="arrow-down"
                                class="o-opening__arrow"
                            />
                            <State />
                            {{ openingDataForToday.data }}
                        </span>
                        <span class="o-opening__time">
                            {{ openingDataForToday.hours |hoursArrayToSring |hoursToHuman }}
                        </span>
                    </span>
                </span>
                <ul
                    v-if="restaurant.businessHours.hours"
                    class="o-opening__list"
                >

                    <li
                        v-for="(day, key, i) in restaurant.businessHours.hours"
                        v-if="day.data"
                        :key="day.data"
                        class="o-opening__item"
                        itemprop="openingHours"
                        :content="key.substring(0, 2) + ' ' + (day.hours) | hoursArrayToSring"
                    >
                        <span class="o-opening__day">{{ day.data }}</span>
                        <span class="o-opening__time">
                            <span>{{ day.hours |hoursArrayToSring |hoursToHuman }}</span>
                        </span>
                    </li>

                </ul>
            </div>

            <div class="l-footer__bottom">

                <router-link to="/fr" :title="siteName" class="l-footer__logo">
                    <Icon icon="logo-text" />
                </router-link>

                <Btn
                    v-if="restaurant && restaurant.booking.url"
                    tag="a"
                    :label="restaurant.booking.label"
                    :title="`${restaurant.booking.label} avec ${restaurant.booking.name}`"
                    :href="restaurant.booking.url"
                    target="_blank"
                    rel="noopener"
                    class="c-btn--filled-light | l-footer__book"
                />

                <Btn
                    tag="a"
                    href="/fr/commande-en-ligne/#/?service=takeout"
                    label="Commander en ligne"
                    title="Commander en ligne sur"
                    class="c-btn--filled | l-footer__order"
                >
                    Commander en ligne
                </Btn>

                <span class="l-footer__rights">
                    <span>Design et code par <a href="http://mambomambo.ca" title="MamboMambo - Image de marque, design graphique et web" ref="noopener" class="t-link">MamboMambo</a></span>
                    <span>Tous droits réservés - {{ siteName }} &copy;2019</span>
                </span>
            </div>
        </div>
    </footer>
</template>

<script>/* eslint-disable */

    import State from 'components/State'
    import Icon from 'components/Icon'
    import Btn from 'components/Btn'

	import moment from 'moment'

    export default {
        name: 'AppFooter',
        components: {
            State,
            Icon,
            Btn
        },
        props: {
            restaurant: {
                type: Object
            }
        },
        computed: {

            site()  {

                if ( !this.$store.state.site.site )
                    return

                return this.$store.state.site.site

            },
            siteName() {

                if ( !this.site )
                    return

                return this.site.settings.site_name

            },
            googleMapQuery() {

                if ( !this.restaurant )
                    return

                let query = this.restaurant.title + ' ' + this.restaurant.address
                return query.replace(' ','+')

            },
            today() {

                const now = moment().locale('en')
                return now.format('dddd').toLowerCase()

            },
            openingDataForToday() {

                if ( !this.today )
                    return

                if ( !this.restaurant )
                    return

                const hours = this.restaurant.businessHours.hours
                const today = this.today

                return hours[today]

            }


        }
    }
</script>

<style scoped>
</style>
